import { Control as LeafletControl } from 'leaflet';
import L from 'leaflet';
import { withLeaflet } from 'react-leaflet';
import { MapControl } from 'react-leaflet';
import PropTypes from 'prop-types';

class LocateButton extends MapControl {
  createLeafletElement({ position = 'topleft', onClick }) {
    L.Control.LocateButton = LeafletControl.extend({
      onAdd: function() {
        var div = L.DomUtil.create('div');
        div.classList.add('leaflet-control');
        div.classList.add('leaflet-bar');
        div.classList.add('locate-button');
        var a = L.DomUtil.create('a');
        a.setAttribute('title', 'Show myself');
        a.addEventListener('click', onClick);
        a.setAttribute('role', 'button');
        div.appendChild(a);
        return div;
      },
    });

    L.control.locateButton = function(opts) {
      return new L.Control.LocateButton(opts);
    };

    let el = L.control.locateButton({ position: position });
    return el;
  }
}

LocateButton.propTypes = {
  position: PropTypes.object,
};

export default withLeaflet(LocateButton);
